import { useContext } from 'react';
import StandardizedDataTable from '../../PrimeAids/StandardizedDataTable';
import { ReportContext } from '../../../context/ReportContext';
import ExpandableInfoCard, {
    ExpandableInfoCardDescription,
    ExpandableInfoCardDetail,
} from '../../Cards/ExpandableInfoCard';

const UsageSummary = () => {
    const { reportData } = useContext(ReportContext);

    const columns = [
        { field: 'clientName', name: 'Client', dataType: 'string' },
        { field: 'cobrandName', name: 'Cobrand', dataType: 'string' },
        { field: 'userRegistrations', name: 'User Registrations', dataType: 'numeric' },
        { field: 'coursesStarted', name: 'Started a Course', dataType: 'numeric' },
        { field: 'coursesCompleted', name: 'Completed a Course', dataType: 'numeric' },
        { field: 'checkupsStarted', name: 'Started a Checkup', dataType: 'numeric' },
        { field: 'checkupsCompleted', name: 'Completed a Checkup', dataType: 'numeric' },
        { field: 'articlesRead', name: 'Read An Article', dataType: 'numeric' },
        { field: 'videosWatched', name: 'Watched A Video', dataType: 'numeric' },
        { field: 'journalsWritten', name: 'Wrote A Journal', dataType: 'numeric' },
    ];

    return (
        <div className="space-y-6">
            <StandardizedDataTable data={reportData} columns={columns} />
            <ExpandableInfoCard title="What is this data?">
                <ExpandableInfoCardDescription>
                    This summary highlights client-level engagement across the platform
                    for the selected reporting window and filters.
                </ExpandableInfoCardDescription>
                <ExpandableInfoCardDetail name="User Registrations">
                    The number of users who completed their registration and created their
                    account, either by manual account creation or initial login by SSO.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Courses Started / Completed">
                    The number of users that started and completed courses.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Checkups Started / Completed">
                    The number of users that started and completed financial checkup
                    assessments.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Read An Article">
                    The number of users that read content items sourced from Articles,
                    Landing Pages, Start Here Guides, and Infographics.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Watched A Video">
                    The number of users that watched videos, including embedded content
                    throughout the site.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Wrote A Journal">
                    The number of users that wrote journal entries.
                </ExpandableInfoCardDetail>
            </ExpandableInfoCard>
        </div>
    );
};

export default UsageSummary;
